import ServiceDetail from "@/components/ServiceDetail";

const description = [
  "Genspire's Payroll Management service helps organizations streamline and manage their payroll processes efficiently, accurately and in a structured manner. Payroll is an essential part of workforce management, requiring timely processing, accurate employee information and consistent coordination — and as businesses grow, managing payroll internally can become increasingly complex and time-consuming.",
  "Genspire provides comprehensive payroll management support designed to simplify these processes and help you maintain an organized payroll function. Depending on your requirements, our support can cover salary processing, attendance and leave inputs, employee records, payroll documentation, payslip coordination and other payroll-related administrative activities.",
  "We work closely with your business to understand your existing payroll processes and provide a structured approach that aligns with your workforce requirements. Our focus is on maintaining accuracy, confidentiality, timely coordination and consistency throughout every payroll cycle.",
  "By partnering with Genspire for payroll management, you can reduce the administrative workload associated with payroll and allow your HR and management teams to focus on strategic workforce initiatives and core business priorities. Whether you are a growing business looking to establish a more organized payroll process or an established organization seeking reliable payroll support, our solutions are structured around your specific operational requirements.",
];

const steps = [
  { title: "Understand", text: "We map your existing payroll process, workforce structure, and reporting requirements." },
  { title: "Structure", text: "A clear payroll calendar and input process designed around how your organization operates." },
  { title: "Process", text: "Accurate, timely payroll cycles with organized documentation and payslip coordination." },
  { title: "Support", text: "Consistent coordination and administration, cycle after cycle, as your workforce grows." },
];

const benefits = [
  "Reduced administrative workload for HR and management teams",
  "Accurate, timely, and consistent payroll cycles",
  "Confidential handling of employee information and records",
  "Organized documentation and payslip coordination every cycle",
  "A structured payroll process that scales as your workforce grows",
  "More time for strategic workforce initiatives and core business priorities",
];

export default function PayrollManagement() {
  return (
    <ServiceDetail
      headlineTop="Payroll"
      headlineAccent="Management."
      tagline="Accurate, organized and efficient payroll support."
      description={description}
      steps={steps}
      benefits={benefits}
      benefitsHeading="Why Organizations Outsource Payroll"
      submitLabel="Talk to Our Team"
      pageTestId="payroll-page"
      ctaTitle="Talk to Our Team"
      ctaSub="Tell us about your payroll process — we'll structure the right support around it."
    />
  );
}
